/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          : ConfirmationEmail.tsx
*
* Project Title : Checkout
*
* Description   : Initial version
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H224423 (Added Modification History)
*
* @Date         : Oct 21, 2019
*
* @Version      : Version 1.0
*
 * By            : H224423
 * On            : Oct 21, 2019
 * Description   : ASDS-1548 changes. Added Modification History.
******************************************************************************/
import * as React from "react";
import {Grid,Table} from "@scuf/common";

//This function is used to display Confirmation Email component
function ConfirmationEmail(props) {
    return (
        <React.Fragment>
            <Grid.Row>
                <Grid.Column width={12} className="paddingbottom">
                    <span className="ro-heading-text">Confirmation Email</span>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={12} className="paddingbottom">
                    <hr className="ro-hr-line" />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={12}>
                    <Table className="plainTable unstackable">
                        <Table.Body>
                            {
                                props.emailAddressArr.map((obj) => {
                                    return (<Table.Row key={obj.address}><Table.Cell>{obj.address}</Table.Cell></Table.Row>);
                                })
                            }
                        </Table.Body>
                    </Table>
                </Grid.Column>
            </Grid.Row>
        </React.Fragment>
    );
}

export default ConfirmationEmail;